import { useEffect, useState } from 'react';
import IrisAssembly from './IrisAssembly';

const ALREADY_SEEN =
  typeof sessionStorage !== 'undefined' && !!sessionStorage.getItem('fl_seen');

export default function IrisIntro({ onDone }) {
  const [phase, setPhase] = useState('play');

  useEffect(() => {
    sessionStorage.setItem('fl_seen', '1');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      onDone();
      setPhase('gone');
      return;
    }
    const revealAt = ALREADY_SEEN ? 350 : 1900;
    const fadeAt = ALREADY_SEEN ? 350 : 2450;
    const t1 = setTimeout(onDone, revealAt);
    const t2 = setTimeout(() => setPhase('fade'), fadeAt);
    const t3 = setTimeout(() => setPhase('gone'), fadeAt + 600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (phase === 'gone') return null;

  return (
    <div
      data-testid="iris-intro"
      className={`fixed inset-0 z-[150] flex items-center justify-center bg-black transition-opacity ${
        ALREADY_SEEN ? 'duration-300' : 'duration-500'
      } ${phase === 'fade' ? 'opacity-0' : 'opacity-100'}`}
    >
      {!ALREADY_SEEN && <IrisAssembly color="yellow" label="F&L GROUP" size={210} />}
    </div>
  );
}
